import { axiosGet, axiosPost } from "../../apis/useAxios";

// Tracking page API calls. Airports come from activityLocationService.getAirportDropdown (shared lookup).

const airlineCode = () => sessionStorage.getItem("session_airlineCode") ?? "";

/** POST Tracking: the vehicles on job of the airline, optionally of one airport / transport vendor. */
export async function getTracking({ airportCode = "", transporterId = 0 } = {}, options) {
  const response = await axiosPost(
    "Tracking",
    { AirlineCode: airlineCode(), TransporterId: transporterId || 0, AirportCode: airportCode || "", RideId: 0 },
    options,
  );
  // The controller answers null on a server error; "no record" just means no vehicle on job.
  if (!response || (response.isSuccess === false && !/no record/i.test(response.message ?? "")))
    throw new Error(response?.message || "Unable to load the vehicles on job.");
  return response.payload ?? [];
}

/** GET Account/get-transport-dropdown: transport vendors { id, name }. */
export async function getVendors() {
  const response = await axiosGet("Account/get-transport-dropdown");
  return response?.payload ?? [];
}
